import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/workspace/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/workspace/src/components/header.tsx");
